import { render } from "./ExpertiseForm.vue?vue&type=template&id=1b1315f7&scoped=true"
import script from "./ExpertiseForm.vue?vue&type=script&lang=js"
export * from "./ExpertiseForm.vue?vue&type=script&lang=js"

import "./ExpertiseForm.vue?vue&type=style&index=0&id=1b1315f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1315f7"]])

export default __exports__